/**
 * [READ ONLY STORE]
 *
 * Footer Links Global Data
 */

import navData from "~/data/footer-links.yaml";

export const state = () => {
    return navData.items.map((item, index) => {
        return { index, ...item };
    });
};
